import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/store'
import canUserAccessRoute from '@/utils/canUserAccessRoute'
import { Role } from '@/constants/constants'

Vue.use(VueRouter)

const routes = [
  {
    path: '/auth',
    name: 'auth',
    props: true,
    component: () => import('@/views/Auth/Auth'),
    meta: {
      guards: [
        { roles: Role.Guest },
        { redirect: '/' }
      ]
    }
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('@/views/Welcome/Welcome'),
    meta: {
      title: 'Welcome',
      guards: [
        { roles: Role.Unsubscribed },
        { redirect: '/' }
      ]
    }
  },
  {
    path: '/widget',
    component: () => import('@/views/Widget/Widget'),
    meta: {
      title: 'Widget',
      guards: [
        { roles: Role.Starter },
        { redirect: '/welcome' }
      ]
    },
    children: [
      {
        path: '',
        redirect: 'discounts'
      },
      {
        path: 'discounts',
        name: 'widget-discounts',
        component: () => import('@/views/Widget/views/Discounts/Discounts'),
        meta: {
          title: 'Discounts'
        }
      },
      {
        path: 'settings',
        name: 'widget-settings',
        component: () => import('@/views/Widget/views/Settings/Settings'),
        meta: {
          title: 'Settings',
        }
      }
    ]
  },
  {
    path: '/widget/discounts/:id',
    name: 'widget-discounts-discount',
    props: true,
    component: () => import('@/views/Widget/views/Discounts/views/Discount/Discount')
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('@/views/Account/Account'),
    meta: {
      title: 'Account',
      guards: [
        { roles: Role.Starter },
        { redirect: '/' }
      ]
    },
    children: [
      {
        path: '',
        redirect: 'settings'
      },
      {
        path: 'settings',
        name: 'account-settings',
        component: () => import('@/views/Account/views/Settings/Settings'),
        meta: {
          title: 'Settings'
        }
      },
      {
        path: 'plans',
        name: 'account-plans',
        component: () => import('@/views/Account/views/Plans/Plans'),
        meta: {
          title: 'Plans'
        }
      }
    ]
  },
  {
    path: '/help',
    component: () => import('@/views/Help/Help'),
    meta: {
      title: 'Help'
    },
    children: [
      {
        path: '',
        redirect: 'guides'
      },
      {
        path: 'guides',
        name: 'help-guides',
        component: () => import('@/views/Help/views/Guides/Guides'),
        meta: {
          title: 'Guides'
        }
      },
      {
        path: 'contact',
        name: 'help-contact',
        component: () => import('@/views/Help/views/Contact/Contact'),
        meta: {
          title: 'Contact'
        }
      }
    ]
  },
  {
    path: '/actions',
    name: 'actions',
    component: () => import('@/views/Actions/Actions'),
    children: [
      {
        path: 'sync',
        name: 'sync',
        component: () => import('@/views/Actions/views/Sync/Sync')
      },
      {
        path: 'add-discount',
        name: 'add-discount',
        props: route => ({ id: route.query.id }),
        component: () => import('@/views/Actions/views/AddDiscount/AddDiscount')
      }
    ]
  },
  {
    path: '*',
    redirect: '/widget'
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
  base: process.env.BASE_URL
})

router.beforeEach((destination, origin, next) => {
  if (destination.path === origin.path) return next()
  if (!store.state.user) return (destination.path === '/auth' && destination.params.destination) ? next() : next({ name: 'auth', params: { destination } })
  const { authorized, redirect } = canUserAccessRoute(destination, store.getters.roles)
  if (authorized) return next()
  return next(redirect)
})

export const createLinks = (paths) => paths.map(path => {
  let route = router.resolve({ path }).route
  const authorized = !!canUserAccessRoute(route, store.getters.roles).authorized
  route = route.path !== path ? route.matched.find(route => route.path === path) : route
  return {
    authorized,
    path: route.path,
    title: route.meta && route.meta.title
  }
})

router.afterEach(() => {
  setTimeout(Vue.prototype.$segment.page, 5)
})

export default router
